<template>
  <div>
    <div style="color:red;" v-if="flag == 'edit'">{{UploadMessage}}</div>
  <div class="images">
     <input type="file" @change="uploadimage" ref="xlsxbutton" :accept="UploadAcc" style="display:none">
     
    <vuedraggable v-model="imagelist" :group="objid" @end="enddrag" class="images" :disabled="flag =='edit' ? false:true">
        <div :class="flag == 'edit' ? 'uploaditem' : 'showitem'" v-for="(drag, index) in imagelist" :id="index" :key="drag.file_id">
          <img :src="drag.file_surl" v-if="flag == 'edit'" @click="showimg(index)" />
          <img :src="drag.file_url" v-else @click="showimg(index)" />
          <div class="deleteitem"  v-if="flag == 'edit'">
            <i class="el-icon-edit-outline" title="修改文件名" style="font-size: 25px; color: #c0c4cc"  @click="editimage(drag, index)"></i>
            <i class="el-icon-circle-close" title="删除文件"  style="font-size: 25px; color: #c0c4cc"  @click="deleteimage(drag, index)"></i>
          </div>
          <div style="font-size:10px;height:50px;text-align:center;">
          {{drag.file_name}}
          </div>
      </div>
    </vuedraggable>
    
    <div class="uploaditem" @click="changefile" v-if="flag == 'edit' && maximgs>=imagelist.length">
      <i class="el-icon-plus" style="font-size: 50px; color: #c0c0c0"></i>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" append-to-body title="文件预览" :fullscreen="true" style="background-color: #eee;text-align: center;" @opened="open">
        <el-carousel  :autoplay="false" arrow="always" :initial-index="currentindex" :height="hh+'px'" ref="pics" :loop="false">
            <el-carousel-item v-for="item in imagelist" :key="item.file_url">
              <div>{{item.file_name}}</div>
              <iframe :src="item.file_url" v-if="item.file_ext=='.pdf'" style="height:100%;width:100%;"></iframe>
              <img :src="item.file_url" v-else height="100%;"/>
            <!-- <el-image :src="item.apurl" lazy style="height:100%;"></el-image> -->
            </el-carousel-item>
        </el-carousel>
    </el-dialog>
  </div>
</div>
</template>

<script>
import { stringify } from 'querystring';
import vuedraggable from 'vuedraggable';
export default {
  components: {vuedraggable},
  data() {
    return {
      imagelist: [],
      dialogFormVisible:false,
      currentindex:0,
      hh:500,
      enddrages:[],
      UploadMessage:'请上传jpg/jpeg/pdf格式文件，单个文件上传最大为5Mb',//附件上传提示；方向：B：单位创建申请 A：其它
      UploadAcc:'image/jpeg,application/pdf',
      UploadSize:5242880
    };
  },
  props: {
    objid: {
      //文件保存在什么对象下面
      type: String,
      default() {
        return "";
      },
    },
    sqladd: {
      //更新到数据库中
      type: Boolean,
      default() {
        return "true";
      },
    },
    flag: {
      //编辑状态：edit可以上传，show:只能查看，不是能上传
      type: String,
      default() {
        return "edit";
      },
    },
    maximgs:{
      type:Number,
      default(){
        return 30;
      }
    },
    objtype:{
      //单位创建申请：B,其它：A
      type:String,
      default(){
        return "A"
      }
    }
  },
  // updated() {
  //   console.log('updated')
  //   let that = this
  //     that.PostData('SYS/UpdateFileOid',that.imagelist,function(res){
  //     },function(err){
  //       that.$alert(err, {title: "错误"});
  //     })
  // },
  mounted() {
    let that = this;
    if(that.objtype == "B"){
      that.UploadAcc = that.SYS.uploadset.acc2
      that.UploadMessage = that.SYS.uploadset.message2
      that.UploadSize = that.SYS.uploadset.size2
    }else{
      that.UploadAcc = that.SYS.uploadset.acc
      that.UploadMessage = that.SYS.uploadset.message
      that.UploadSize = that.SYS.uploadset.size
    }
    this.hh = document.documentElement.clientHeight - 80;
    that.getlist();    
    // that.$dragging.$on("dragged", ({ value }) => {      
      
    //   that.enddrages = value.list;//JSON.parse(JSON.stringify(value.list)) 
    // });
    // that.$dragging.$on("dragend", () => {
    //   that.PostData('SYS/UpdateFileOid',that.enddrages,function(res){
    //     console.log(that.objid)
    //     that.imagelist = that.enddrages
    //     //that.getlist();
    //   },function(err){
    //     that.$alert(err, {title: "错误"});
    //   })
    // });
  },
  watch:{
      objid:{
        handler(n,o){
          this.getlist()
        },
        deep:true
      }
  },
  methods: {
    enddrag(){
      let that = this
      that.PostData('SYS/UpdateFileOid',that.imagelist,function(res){

      },function(err){
        that.$alert(err, {title: "错误"});
      })
    },
    getlist(){
        let that = this
        that.imagelist = []
        let wherestring = [{field: 'new_id',sym: '=',val:that.objid,oper: 'and'}]
        let pars = {objname: "new_newsfiles",wheres: wherestring,PageSize: 50,CurrentPage: 1,orderbys:[{field:'file_oid',asc:'asc'}]}
        that.PostData("Common/GETLIST", pars,function (res) {
          res.data.data.forEach(element => {
            that.imagelist.push(element)
          });
        },function (err) {
          that.$alert(err, {title: "错误"});
        });
    },
    changefile: function () {
        this.$refs.xlsxbutton.value = "";
        this.$refs.xlsxbutton.click();
    },
    uploadimage(e) {        
      let that = this;
        var files = e.target.files || e.dataTransfer.files;
        if (files.length > 1) {
            that.$alert("一次只能上传1个文件。", {
            title: "错误"
            });
            that.$refs.xlsxbutton.value = "";
            return;
        }
        if (files[0].size > that.UploadSize) {
            that.$alert(that.UploadMessage, {
            title: "错误"
            });
            that.$refs.xlsxbutton.value = "";
            return;
        }
        const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        let filename = files[0].name.substring(0, files[0].name.lastIndexOf("."));
        that.$prompt('请输入文件名称','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          inputPattern:/'*/,
          inputPlaceholder: "请输入文件名称",
          inputValue: filename,
          inputErrorMessage:'文件名不符合要求',
          showClose:false
        }).then(({value})=>{
          that.PostFile(
            "SYS/uploadBigFile",
            {
              objid: that.objid,
              filename:value,
              sqladd: that.sqladd,
            },
            files[0],
            function (res) {
              let obj = res.data.obj;
              that.imagelist.push(obj);
              loading.close()
            },function(err){
                that.$alert(err, {
                  title: "错误"
                });
                loading.close()
            },
            function(press){
                console.log(press)
            }
          );
        }).catch(() => {
          that.$refs.xlsxbutton.value = "";
          loading.close()      
        });
          
    },
    editimage(item,index){
      let that = this
      let filename = item.file_name;
      that.$prompt('请输入文件名称','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          inputPattern:/'*/,
          inputPlaceholder: "请输入文件名称",
          inputValue: filename,
          inputErrorMessage:'文件名不符合要求',
          showClose:false
        }).then(({value})=>{
          that.PostData('Common/UPDATE',{objname:'new_newsfiles',keyfield:'file_id',keyvalue:item.file_id,fields:{file_name:value}},function(res){
            item.file_name = value;
            that.$set(that.imagelist, index, item);
          })
        }).catch(()=>{

        })
    },
    deleteimage(item, index) {
      let that = this
      that.$confirm('确定要删除此文件吗?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
            that.GetData(
              "SYS/DeleteImg",
              { file_id: item.file_id },
              function (res) {
                that.imagelist.splice(index, 1);
              }
            );
      }).catch(()=>{});
    },
    showimg(index) {
      let that = this;
      console.log(index)
      that.currentindex = index
      that.dialogFormVisible = true;
    },
    open(){
      this.$refs.pics.setActiveItem(this.currentindex)
    }
  },
};
</script>

<style lang="less" scoped>
.images {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.uploaditem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px dashed #c0c0c0;
  background-color: #fbfdff;
  width: 148px;
  height: 198px;
  margin: 5px;
  position: relative;
  img {
    width: 148px;
    height: 148px;
  }
}
.showitem {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  text-align: center;
  width: 148px;
  height: 198px;
  margin: 5px;
  position: relative;
  img {
    width: 148px;
    height: 148px;
  }
}
.deleteitem {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>